import { dynamicLoader } from '~/utils';

export const EstimateCategoriesPage = dynamicLoader({
  name: 'EstimateCategoriesPage',
  importFunc: () => import('./estimate-categories'),
});